import { render, staticRenderFns } from "./GRadio.vue?vue&type=template&id=9ef4015c&"
import script from "./GRadio.vue?vue&type=script&lang=js&"
export * from "./GRadio.vue?vue&type=script&lang=js&"
import style0 from "./GRadio.vue?vue&type=style&index=0&id=9ef4015c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports